import { useContext } from 'react';

import { SettingsContextProps } from '../@types/settings';
import { SettingsContext } from '../contexts/SettingsContext';

const useSettings = (): SettingsContextProps => useContext(SettingsContext);

export default useSettings;
